import styled from "styled-components";

import FnrShineButton, { FnrShineButtonWrapper } from "../FnrShineButton";

export default function SignupItem({
  title,
  icon,
  count = 0,
  max,
  highlightColor,
}) {
  return (
    <Wrapper>
      <FnrShineButton tapScale={0.98} shineColor={highlightColor}>
        <Inside>
          <TitleArea>
            <Icon>
              <i className={icon} />
            </Icon>
            <Title>{title}</Title>
          </TitleArea>
          <CountContainer>
            <CountNumber>{count}</CountNumber>
            {max && <CountMax>{max}</CountMax>}
          </CountContainer>
        </Inside>
      </FnrShineButton>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  display: flex;
  cursor: pointer;
  position: relative;
  margin: 2px 0;
  & ${FnrShineButtonWrapper} {
    width: 100%;
  }
`;
const Inside = styled.div`
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;
  padding: 4px 12px;
  padding-right: 4px;
`;
const TitleArea = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
const Icon = styled.div`
  width: 20px;
  font-size: 16px;
  text-align: center;
`;
const Title = styled.div`
  font-size: 16px;
  position: relative;
`;
const CountContainer = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  border: 1px solid #fff;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.2) 1px 1px 4px;
  text-shadow: none;
`;
const CountNumber = styled.div`
  padding: 2px 7px;
  color: var(--sectionColor);
  background: #fff;
  position: relative;
  z-index: 10;
  font-weight: bold;
  &:not(:last-child) {
    padding-right: 3px;
    &:after {
      content: "";
      display: block;
      position: absolute;
      top: -3px;
      bottom: -3px;
      width: 6px;
      left: 100%;
      background: #fff;
      transform: rotate(15deg);
      margin-left: -3px;
      z-index: -1;
    }
  }
`;
const CountMax = styled.div`
  padding: 2px 7px;
  padding-left: 8px;
`;
